import { Action, RootState } from "../../index";
import { Dispatch } from "react-redux";

import API from "../../../vendor/api";
import { normalize } from "normalizr";
import * as schema from "../../schema";

import { IChatNormalized, IChatDetails, IUser } from "../../../types";

import { addChatEntities, addChatEntity } from "../chats/chats";
import { selectChat } from "../ui/ui";
import { addMessageEntities, setMessageEntities, addMessageEntity, addMessageEntitiesPosition } from "../messages/messages";

/**
 * Actions
 */

// Fetch chats
export const FETCH_CHATS_REQUEST = "meumedico/chats/FETCH_CHATS_REQUEST";
export function fetchChatsRequest() {
    return {
        type: FETCH_CHATS_REQUEST
    };
}

export const FETCH_CHATS_SUCCESS = "meumedico/chats/FETCH_CHATS_SUCCESS";
export function fetchChatsSuccess(chats: IChatDetails[]) {
    return {
        type: FETCH_CHATS_SUCCESS,
        payload: {
            chats
        }
    };
}

export const FETCH_CHATS_FAILURE = "meumedico/chats/FETCH_CHATS_FAILURE";
export function fetchChatsFailure() {
    return {
        type: FETCH_CHATS_FAILURE
    };
}

export const ACCEPT_CHAT_INVITATION_REQUEST = "zig/chats/ACCEPT_CHAT_INVITATION_REQUEST";
function acceptChatInvitationRequest() {
    return {
        type: ACCEPT_CHAT_INVITATION_REQUEST
    };
}

export const ACCEPT_CHAT_INVITATION_FAILURE = "zig/chats/ACCEPT_CHAT_INVITATION_FAILURE";
function acceptChatInvitationFailure(error: any) {
    return {
        error,
        type: ACCEPT_CHAT_INVITATION_FAILURE
    };
}

export const ACCEPT_CHAT_INVITATION_SUCCESS = "zig/chats/ACCEPT_CHAT_INVITATION_SUCCESS";
function acceptChatInvitationSuccess(json: any) {
    return {
        type: ACCEPT_CHAT_INVITATION_SUCCESS,
        payload: {
            json
        }
    };
}

export function acceptChatInvitation(id: string) {
    return function (dispatch: Dispatch<any>) {
        dispatch(acceptChatInvitationRequest());

        API.acceptAndJoinChat(id).then(res => {
            dispatch(fetchChats());
            dispatch(markAsRead(id));
            dispatch(acceptChatInvitationSuccess(res));
        }).catch(err => {
            dispatch(acceptChatInvitationFailure(err));
        });
    };
}

export const REFUSE_CHAT_INVITATION_REQUEST = "zig/chats/REFUSE_CHAT_INVITATION_REQUEST";
function refuseChatInvitationRequest() {
    return {
        type: REFUSE_CHAT_INVITATION_REQUEST
    };
}

export const REFUSE_CHAT_INVITATION_FAILURE = "zig/chats/REFUSE_CHAT_INVITATION_FAILURE";
function refuseChatInvitationFailure(error: any) {
    return {
        error,
        type: REFUSE_CHAT_INVITATION_FAILURE
    };
}

export const REFUSE_CHAT_INVITATION_SUCCESS = "zig/chats/REFUSE_CHAT_INVITATION_SUCCESS";
function refuseChatInvitationSuccess(json: any) {
    return {
        type: REFUSE_CHAT_INVITATION_SUCCESS,
        payload: {
            json
        }
    };
}

export function refuseChatInvitation(id: string) {
    return function (dispatch: Dispatch<any>) {
        dispatch(refuseChatInvitationRequest());

        API.refuseAndDeleteChat(id).then(res => {
            dispatch(fetchChats());
            dispatch(selectChat(""));
            dispatch(refuseChatInvitationSuccess(res));
        }).catch(err => {
            dispatch(refuseChatInvitationFailure(err));
        });
    };
}

export function fetchChats() {
    return (dispatch: Dispatch<any>) => {
        dispatch(fetchChatsRequest());

        API.listChats().then(chats => {
            // console.log({chats});
            const normalizr = normalize(chats, schema.chats);
            // console.log(normalizr);
            dispatch(addChatEntities(normalizr.entities.chat));
            dispatch(setMessageEntities(normalizr.entities.message));
            dispatch(fetchChatsSuccess(chats));
        }).catch(e => {
            console.error(e);
            fetchChatsFailure();
        });
    };
}

// Listen messages
export function listenMessages(since: Date, currentUser: IUser) {
    return (dispatch: Dispatch<any>, getState: () => RootState) => {
        API.listenMessages(since, (message) => {
            let selectedChat = getState().ui.chats.selected;
            console.log(message);
            switch (message.type) {
                // case API.MessageType.MetaMemberInvited:

                case API.MessageType.MetaMemberJoined:
                    let chat: IChatNormalized;

                    if (message.chat && message.chat.is_group) {
                        chat = Object.assign({}, message.chat, {
                            messages: [],
                            unread_count: 0,
                            is_member: message.user && message.user.id === currentUser.id
                        });
                        dispatch(addChatEntity(chat));
                    } else if (message.user && currentUser.id !== message.user.id) { // É usuáriio
                        chat = {
                            id: message.chat_id,
                            name: message.user.name,
                            avatar: message.user.avatar,
                            is_group: false,
                            unread_count: 0,
                            messages: []
                        };
                        dispatch(addChatEntity(chat));
                    }

                default:
                    dispatch(addMessageEntity(message, currentUser.id, selectedChat));
            }
        });
    };
}

// Send message
export function sendMessage(clientId: string, message: string, chatId: string) {
    return (dispatch: Dispatch<any>) => {
        let messageObj: API.MessageToSend = {
            id: clientId,
            chat_id: chatId,
            type: API.MessageType.Text,
            text: message
        };

        API.sendMessage(messageObj).then(res => {
        });
    };
}

// Get messages
export function getMessages(chatId: string, since: Date) {
    return (dispatch: Dispatch<any>) => {
        API.getMessages(chatId, since, 30).then(messages => {
            const normalizr = normalize(messages, schema.messages);
            dispatch(addMessageEntities(normalizr.entities.message || [], addMessageEntitiesPosition.Prepend, chatId));
        });
    };
}

// Fetch chats
export const MARK_CHAT_AS_READ_SUCESS = "meumedico/chats/MARK_CHAT_AS_READ_SUCESS";
export function markChatAsReadSuccess(chatId: string) {
    return {
        type: MARK_CHAT_AS_READ_SUCESS,
        payload: {
            chatId
        }
    };
}

// Mark chat as read
export function markAsRead(chatId: string) {
    return (dispatch: Dispatch<any>) => {
        API.markMessagesAsRead(chatId).then(res => {
            dispatch(markChatAsReadSuccess(chatId));
        });
    };
}

export function createGroup(name: string, doctorIds: string[]) {
    return (dispatch: Dispatch<any>) => {
        API.createGroupChat(doctorIds, name, new Buffer("")).then(res => {
            console.log(res);
        });
    };
}

export function createGroupWithPatient(name: string, doctorIds: string[], patientIds: string[]) {
    return (dispatch: Dispatch<any>) => {
        API.createGroupChatWithPatients(doctorIds, patientIds, name, new Buffer("")).then(res => {
            console.log(res);
        });
    };
}

export function inviteUserToChat(chatId: string, profileId: string) {
    return (dispatch: Dispatch<any>) => {
        API.inviteUserToChat(chatId, profileId).then(res => {
            console.log(res);
        });
    };
}

/**
 * Reducer
 **/

export interface AppChatsState {
}

export default function reducer(state: AppChatsState = {}, action: Action<any>) {
    switch (action.type) {
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/appChats/appChats.ts